module.exports = __webpack_public_path__ + "static/team16-419e36d412a0ed877c757d2d245f9f9a.jpg";